import { Component, EventEmitter, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router, UrlSegment } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { AppSettings } from '../../app.settings';
import { Settings } from '../../app.settings.model';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  providers: [TranslatePipe]
})
export class BreadcrumbComponent {
  @Output('moduleTitle')
  moduleTitle: EventEmitter<any> = new EventEmitter<any>();
  public pageTitle: string;
  public breadcrumbs: {
    name: string;
    url: string;
    visable: boolean;
    isClickable: boolean;
  }[] = [];

  public settings: Settings;
  constructor(
    public appSettings: AppSettings,
    public router: Router,
    private translatePipe: TranslatePipe,
    public activatedRoute: ActivatedRoute,
    public title: Title
  ) {
    this.settings = this.appSettings.settings;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.breadcrumbs = [];
        this.parseRoute(this.router.routerState.snapshot.root);
        this.pageTitle = '';
        this.breadcrumbs.forEach(breadcrumb => {
          this.pageTitle += ' > ' + breadcrumb.name;
        });
        const indx = this.pageTitle.lastIndexOf(' ');
        const pgTilte = this.pageTitle.substr(indx + 1);
        // this.title.setTitle(this.settings.name + this.pageTitle);
        this.title.setTitle(this.translatePipe.transform(pgTilte));
        // console.log(this.breadcrumbs);
        if (this.breadcrumbs.length > 2) {
          this.moduleTitle.emit(this.breadcrumbs[2].name);
        } else if (this.breadcrumbs.length > 1) {
          this.moduleTitle.emit(this.breadcrumbs[1].name);
        }
      }
    });
  }

  private parseRoute(node: ActivatedRouteSnapshot) {
    if (node.data['breadcrumb']) {
      // if (node.data['visable'] == undefined)
      //     node.data['visable'] = true;
      // else
      //     node.data['visable'] = false;

      if (node.url.length) {
        let urlSegments: UrlSegment[] = [];
        node.pathFromRoot.forEach(routerState => {
          urlSegments = urlSegments.concat(routerState.url);
        });
        const url = urlSegments
          .map(urlSegment => {
            return urlSegment.path;
          })
          .join('/');
        this.breadcrumbs.push({
          name: node.data['breadcrumb'],
          url: '/' + url,
          visable: node.data['visable'] !== undefined ? node.data['visable'] : true,
          isClickable: node.data['isClickable'] !== undefined ? node.data['isClickable'] : true
        });
        if (this.breadcrumbs.length >= 2)
          this.breadcrumbs[1].isClickable = false;
      }
    }
    if (node.firstChild) {
      this.parseRoute(node.firstChild);
    }
  }

  public closeSubMenus() {
    this.router.navigate(['Home/Main']);
    const menu = document.querySelector('.sidenav-menu-outer');
    if (menu) {
      for (let i = 0; i < menu.children[0].children.length; i++) {
        const child = menu.children[0].children[i];
        if (child) {
          if (child.children[0].classList.contains('expanded')) {
            child.children[0].classList.remove('expanded');
            child.children[1].classList.remove('show');
          }
        }
      }
    }
  }
}
